import React,{useMemo} from 'react';
import SectionTitle from '../../components/Common/SectionTitle';
import Footer from '../../components/Layout/Footer';
import SearchModal from '../../components/Layout/Header/SearchModal';
import SiteBreadcrumb from '../../components/Common/Breadcumb';
import ServiceDetailsContent from './ServiceDetailsContent';

// Breadcrumbs Image
import breadcrumbsImg from '../../assets/img/breadcrumbs/2.jpg';
import serviceImg from '../../assets/img/service/main-home/6.png';
import DetailsHeader from '../../components/Layout/Header/DetailsHeader';

const SalesMarketing = () => {
    const content = useMemo(() => {
        return <SectionTitle
            sectionClass="sec-title4"
            descClass="desc desc-big"
            description="Sales and marketing optimization including CRM tuning, lead generation strategies, and performance measurement to drive revenue."
        />
    }, [])
    return (
        <React.Fragment>
            <DetailsHeader
                parentMenu='service'
                secondParentMenu='services'
                activeMenu='/sales-marketing'
            />
            <SiteBreadcrumb
                breadcrumbsImg={breadcrumbsImg}
                pageTitle='Sales & Marketing Optimization'
                pageCategory='Services'
                pageName='Sales & Marketing'
                parentPath="/service"
            />
            <ServiceDetailsContent title="Sales & Marketing Optimization" subtitle="Sales & Marketing" children={content} serviceImg={serviceImg}/>
            <Footer footerClass="rs-footer" />
            <SearchModal />
        </React.Fragment>
    );
}

export default SalesMarketing;
